import Picker, { SliderPickerProps } from "../Picker";

type SetTimeProps = {
  pickers: {
    type: SliderPickerProps["options"]["type"];
    onChangePicker(value: number): void;
    value: string;
    isInf?: boolean
    disabled?: boolean
  }[];
  style?: React.CSSProperties | undefined;
};

function SetTime(props: SetTimeProps) {

  return (
    <div
      style={{
        color: 'white',
        ...props.style || {},
      }} className="text-center">
      <div
        style={{
          fontWeight: 700,
          fontSize: '32px',
          lineHeight: '100%',
          letterSpacing: '0%',
          textAlign: 'center',
          marginBottom: 10,
        }}
      >
        Set Time
      </div>
      <div className="grid grid-cols-3 gap-3 ml-20">
        {props.pickers.map((item, index) => (
          <div

            style={{
              boxShadow: "3px 3px 3px  rgba(0, 0, 0, 0.3)",
            }}
            className="w-32 border-2 border-white rounded-3xl bg-quickStartLeftStepContentBgColor" key={index}>
            <Picker
              key={index}
              options={{
                type: item.type,
                cb: (value) => {
                  const newValue = value === "∞" ? -1 : Number(value);
                  item.onChangePicker(newValue)
                },
                defaultValue: item.value === "-1" ? "∞" : item.value,
                isInf: item.isInf,
                disabled: item.disabled,
              }}
            />
          </div>
        ))}
        <div className="w-32 font-bold text-3xl text-white">Days</div>
        <div className="w-32 font-bold text-3xl text-white">Hours</div>
        <div className="w-32 font-bold text-3xl text-white">Minutes</div>
      </div>
    </div>
  );
}
export default SetTime;
